import { render, staticRenderFns } from "./CarwashCard.vue?vue&type=template&id=3a589c87&"
import script from "./CarwashCard.vue?vue&type=script&lang=js&"
export * from "./CarwashCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports